import React, { createContext, ReactNode, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { useNonFinancialDriversApiView } from '../../hooks/useNonFinancialDriversApiView';

type DriversViewContextValue = ReturnType<typeof useNonFinancialDriversApiView>;

const DriversViewContext = createContext<DriversViewContextValue>(({} as unknown) as DriversViewContextValue);

interface Props {
  children: ReactNode;
}

export const DriversViewProvider = ({ children }: Props) => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const value = useNonFinancialDriversApiView(workspaceId, organisationId);

  return <DriversViewContext.Provider value={value}>{children}</DriversViewContext.Provider>;
};

export const useDriversView = () => {
  const context = useContext(DriversViewContext);
  if (!context) {
    throw new Error('useDriversView must be used within a DriversViewProvider');
  }
  return context;
};
